import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../service/server/server.service';
import { MessageService } from '../../../service/message/message.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-login2',
  templateUrl: './login2.component.html',
  styleUrls: ['./login2.component.scss']
})
export class Login2Component implements OnInit {
  public loading: boolean = false;
  public subscription: Subscription | any;
  public server!: string;
  public userId!: any;
  public userToken!: any;

  constructor(
    public serverService: ServerService,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public activatedRoute: ActivatedRoute,
    public messageService: MessageService,
    public location: Location) {
    this.server = this.serverService.get_server();
  }//end consructor
  ngOnInit() {
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.userToken = params['userToken'];
        this.userId = params['userId'];
      }
    )
    this.activatedRoute.queryParams.subscribe(
      (params: Params) => {
        if (params['admin'] == 1) {
          localStorage.setItem("admin", JSON.stringify(params['admin']));
        }
      }
    )
    if (this.userToken && this.userId) {
      this.check_server_login();
    }
  }//end ngOnInit
  check_server_login() {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6994,
      'userId': this.userId,
      'userToken': this.userToken
    }
    this.subscription = this.serverService.post_address('https://meserver.finty.ir', 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          localStorage.setItem('server', JSON.stringify(res['result'][0].user_server));
          this.login();
        }//end if
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());
        }
      }
    )
  }
  login() {
    this.loading = true;
    var obj = {
      'address': 7244,
      "userToken": this.userToken,
      "userId": this.userId
    }
    this.subscription = this.serverService.post_address_login("https://meserver.finty.ir", 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.set_login(res['result'][0]);
            this.router.navigate(["/home/" + res['result'][0].site_services_link + "/" + res['result'][0].site_services_id]);
          }//end if
          else {

          }
          this.loading = false;
        }//end else if
      }
    )
  }
  set_login(result: any) {
    var user_info = {
      user_id: result.user_id,
      user_creator: result.user_creator2,
      user_token: result.user_token,
    };
    localStorage.setItem("user_info", JSON.stringify(user_info));
    localStorage.setItem('status', '1');
    localStorage.setItem("lang", JSON.stringify(1));
    this.router.navigate(['/home/' + result.site_services_link + '/' + result.site_services_id]);
  }
  //******************************************************************************** */
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy

}